<template>
  <textarea
    :value="modelValue"
    class="survey-question-textarea"
    :placeholder="question.question"
    @input="onChange($event.target.value)"
  ></textarea>
</template>

<script>
export default {
  name: "SurveyQuestionTextarea",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    question: {
      type: Object,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_survey.scss";

.survey-question-textarea {
  @extend %survey-question-control;
  padding: 12px 10px;
  height: auto;
  min-height: 74px;
  resize: vertical;
  line-height: 1.19;

  &::placeholder {
    color: #c0c0c0;
  }
}
</style>
